import { UsTimezoneOption } from 'src/app/models/us-timezone-option.model';

/**
 * Curated list of the main US timezones, shown with human-friendly labels across all
 * timezone dropdowns in the platform. Each entry pairs the IANA zone (persisted in
 * `TimeZone.nameValue`) with the label displayed to the user.
 *
 * Hardcoded on purpose so the picker does not depend on moment-timezone's country metadata
 * being present in the production bundle (that data is a side-effect import in
 * moment-timezone's index.js and can be dropped by tree-shaking).
 */
export const US_TIMEZONES: UsTimezoneOption[] = [
  { label: 'Eastern Time (ET)', zone: 'America/New_York' },
  { label: 'Central Time (CT)', zone: 'America/Chicago' },
  { label: 'Mountain Time (MT)', zone: 'America/Denver' },
  { label: 'Arizona (MST, no DST)', zone: 'America/Phoenix' },
  { label: 'Pacific Time (PT)', zone: 'America/Los_Angeles' },
  { label: 'Alaska Time (AKT)', zone: 'America/Anchorage' },
  { label: 'Hawaii-Aleutian Time (HST)', zone: 'Pacific/Honolulu' },
];
